import {
  ApiCartDeleteCartRequestedAction,
  apiCartDeleteCartFailed,
  apiCartDeleteCartSucceeded
} from '@spa/lib/store/api/cart/deleteCartApi';
import { call, put } from 'typed-redux-saga';
import deleteCartAction, {
  DeleteCartActionInput,
  DeleteCartActionResult
} from '@spa/lib/actions/cart/deleteCartAction';

function* deleteCartSaga({
  payload: { customOrderType, parentActionId, actionId: requestedActionId }
}: ApiCartDeleteCartRequestedAction): Generator {
  try {
    const input: DeleteCartActionInput = { customOrderType };
    const { cartId, result }: DeleteCartActionResult = yield* call(
      deleteCartAction,
      'deleteCartAction',
      input
    );

    yield* put(
      apiCartDeleteCartSucceeded({
        requestedActionId,
        parentActionId,
        result,
        cartId
      })
    );
  } catch {
    yield* put(apiCartDeleteCartFailed({ requestedActionId, parentActionId }));
  }
}

export default deleteCartSaga;
